// extracted by mini-css-extract-plugin
export default {"CheckboxContainer":"CheckboxSimple_CheckboxContainer__E3YN6"};